if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        /* 11.10.2026 — SCHUBLADE SOFORT AUFMACHEN.
           Marvin: "Der add to cart button funktioniert viel zu langsam."

           Diese Datei schickt bereits nur EINE Anfrage: 'sections' und
           'sections_url' gehen oben mit an /cart/add.js, Shopify liefert
           den gerenderten Drawer in derselben Antwort zurueck. Da ist
           nichts mehr einzusparen. Der echte Doppel-Request sass in
           snippets/sticky-add-cart-button.liquid und ist dort erledigt.

           Was bleibt, ist Shopifys Antwortzeit. Die koennen wir nicht
           kuerzen — aber bisher passierte in dieser Zeit sichtbar gar
           nichts ausser einem 18px-Kringel im Knopf. Deshalb tippen
           Leute ein zweites Mal. Jetzt faehrt die Schublade beim Klick
           aus und zeigt, dass sie arbeitet. Die Wartezeit ist dieselbe,
           sie findet nur sichtbar statt.

           Aufgehoben wird der Zustand in cart-drawer.js renderContents(),
           also wenn der neue Inhalt steht. Kein Zeitgeber. */
        if (this.cart && typeof this.cart.openBusy === 'function') {
          this.cart.openBusy();
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              /* 11.10.2026 — Fehlerweg: ausverkauft, Netz weg, Shopify
                 meckert. Dann darf die Schublade nicht mit Kringel
                 stehenbleiben. Liegt schon etwas im Warenkorb, bleibt
                 sie offen — der angezeigte Stand ist dann korrekt, es
                 kam nur nichts dazu. Ist sie leer, geht sie wieder zu. */
              if (this.cart && typeof this.cart.closeBusy === 'function') {
                this.cart.closeBusy(!!document.querySelector('.taep-cart-item'));
              }

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
            /* 11.10.2026 — Reissleine. Wirft renderContents (oder die
               Antwort ist kein JSON), raeumt oben niemand den
               Ladezustand weg und die Schublade bliebe fuer immer
               verdeckt. Hier also dieselbe Regel wie im Fehlerzweig. */
            if (this.cart && typeof this.cart.closeBusy === 'function') {
              this.cart.closeBusy(!!document.querySelector('.taep-cart-item'));
            }
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}


// PDP Product Switch + Bundle Tabs
(function () {

  // AJAX PRODUCT LOAD
  function loadFullProduct(url, push = true) {
    document.body.classList.add('is-loading');

    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(res => res.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');

        const title = doc.querySelector('title');
        if (title) document.title = title.textContent;

        const newMain = doc.querySelector('#MainContent');
        const currentMain = document.querySelector('#MainContent');

        if (!newMain || !currentMain) {
          window.location.href = url;
          return;
        }

        currentMain.replaceWith(newMain);

        if (push) history.pushState({}, '', url);

        reInitAll();

        document.body.classList.remove('is-loading');
        window.scrollTo({ top: 0, behavior: 'auto' });
      })
      .catch(() => window.location.href = url);
  }

  // PRODUCT SWITCH CLICK
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-ignore-product-switch]')) return;

    const item = e.target.closest('.product-switch__item');
    if (!item) return;

    const handle = item.dataset.productHandle;
    if (!handle) return;

    const url = '/products/' + handle;
    if (window.location.pathname === url) return;

    e.preventDefault();
    loadFullProduct(url, true);
  });

  window.addEventListener('popstate', function () {
    loadFullProduct(window.location.pathname, false);
  });

  // PRICE TYPE TOGGLE (FIX)
  function togglePriceType(wrapper) {
    const priceTypeEls = document.querySelectorAll('[data-type="price-type"]');
    const activeTab = wrapper.querySelector('.taep-tab.active');

    if (!activeTab) return;

    const target = activeTab.dataset.target;

    priceTypeEls.forEach(el => {
      el.style.display = target === 'filter' ? 'none' : '';
    });
  }

  // BUNDLE / TAB INIT
  function initBundleTabs() {
    document.querySelectorAll('[data-taep-wrapper]').forEach(wrapper => {
      const tabs = wrapper.querySelectorAll('.taep-tab');
      const panels = wrapper.querySelectorAll('.taep-panel');
      const container = wrapper.closest('.product__info-container');

      const form =
        container?.querySelector('product-form form') ||
        container?.querySelector('form[action="/cart/add"]');
      const idInput = form?.querySelector('input[name="id"]');

      if (!form || !idInput) return;

      function updateVariant(panel) {
        if (!panel) return;

        if (panel.dataset.panel === 'bundle') {
          const el = panel.querySelector('.taep-bundle-product');
          if (el?.dataset.variantId) {
            idInput.value = el.dataset.variantId;
          }
        }

        if (panel.dataset.panel === 'filter') {
          const card = panel.querySelector('.taep-card.is-active');
          if (card?.dataset.variantId) {
            idInput.value = card.dataset.variantId;
          }
        }
      }

      tabs.forEach(tab => {
        tab.onclick = () => {
          const target = tab.dataset.target;

          tabs.forEach(t => t.classList.remove('active'));
          tab.classList.add('active');

          panels.forEach(p => {
            p.classList.toggle('active', p.dataset.panel === target);
          });

          togglePriceType(wrapper);
          updateVariant(wrapper.querySelector('.taep-panel.active'));
        };
      });

      const filterPanel = wrapper.querySelector('.taep-panel[data-panel="filter"]');
      if (filterPanel) {
        const cards = filterPanel.querySelectorAll('.taep-card');

        if (cards.length && !filterPanel.querySelector('.is-active')) {
          cards[0].classList.add('is-active');
        }

        cards.forEach(card => {
          card.onclick = () => {
            cards.forEach(c => c.classList.remove('is-active'));
            card.classList.add('is-active');

            if (filterPanel.classList.contains('active')) {
              updateVariant(filterPanel);
            }
          };
        });
      }

      togglePriceType(wrapper);
      updateVariant(wrapper.querySelector('.taep-panel.active'));
    });
  }

  // READ MORE / LESS
  function initReadMoreLess() {
    document.querySelectorAll('.ps-readmore').forEach(btn => {
      btn.onclick = e => {
        e.stopPropagation();
        btn.closest('.ps-desc')?.classList.add('is-open');
      };
    });

    document.querySelectorAll('.ps-readless').forEach(btn => {
      btn.onclick = e => {
        e.stopPropagation();
        btn.closest('.ps-desc')?.classList.remove('is-open');
      };
    });
  }

  // MASTER RE-INIT
  function reInitAll() {
    initBundleTabs();
    initReadMoreLess();
  }

  // INITIAL LOAD
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reInitAll);
  } else {
    reInitAll();
  }

})();
